import { useEffect, useState } from "react";
import { useAuth } from "../../../context/authProvider"
import { useWatches } from "../../../context/watchProvider";
import LoadingBalls from "../../core/loadingBalls";
import { useNavigate } from "react-router-dom";
import ReviewModal from "./reviewModal";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

export default function MyPurchases() {

    const { userId } = useAuth();
    const { getPurchasedWatches } = useWatches();
    const navigate = useNavigate();

    const [watches, setWatches] = useState<{ [key: string]: any; id: string; }[]>([]);
    const [reviews, setReviews] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [reviewModal, setReviewModal] = useState(false);
    const [reviewWatch, setReviewWatch] = useState<{ [key: string]: any; id: string; } | null>(null);

    useEffect(() => {
        doGetPurchasedWatches();
        getReviews();
        // eslint-disable-next-line
    }, []);

    const doGetPurchasedWatches = async () => {
        if (!userId) {
            return null;
        }
        setLoading(true);
        const data = await getPurchasedWatches(userId);
        if (!data) {
            setLoading(false);
            return null;
        }
        setWatches(data);
        setLoading(false);
    }

    const getReviews = async () => {
        try {
            const q = query(collection(db, "reviews"), where("userId", "==", userId));
            const docsSnap = await getDocs(q);
            if (docsSnap.empty) {
                return null;
            }
            let docs: string[] = [];
            docsSnap.forEach(d => {
                docs.push(d.data().watch);
            })
            setReviews(docs);
        }catch(error){
            console.log(error);
        }
    }

    const handleReviewModal = (watch: { [key: string]: any; id: string; }) => {
        setReviewWatch(watch);
        setReviewModal(true);
    }

    return (
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl shadow-primary/5 border border-primary/5 space-y-8 animate-superfade">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="space-y-2">
                    <h2 className="text-2xl font-black text-primary tracking-tight">Minhas Compras</h2>
                    <div className="w-12 h-1 bg-secondary" />
                </div>
                {watches.some(w => !reviews.includes(w.id)) ? (
                    <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full border border-red-100 shadow-sm animate-pulse">
                        <span className="text-[10px] font-black tracking-widest uppercase">Avaliação Pendente</span>
                    </div>
                ) : null}
            </div>

            {
                !watches?.length ?
                    <div className="py-20 text-center space-y-4 bg-moninho/30 rounded-3xl border border-dashed border-primary/10">
                        <p className="text-mono font-medium">Você ainda não realizou nenhuma compra.</p>
                        <button 
                            onClick={() => navigate('/watches')}
                            className="text-xs font-black tracking-widest text-secondary hover:text-primary transition-colors uppercase"
                        >
                            Explorar Catálogo
                        </button>
                    </div>
                    :
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {
                            loading ?
                                <div className="col-span-full flex justify-center py-20"><LoadingBalls /></div>
                                :
                                watches?.map((w, i) => (
                                    <div 
                                        key={i} 
                                        className="group bg-white rounded-2xl overflow-hidden border border-primary/5 shadow-sm hover:shadow-xl hover:shadow-primary/5 transition-all duration-500 flex flex-col"
                                    >
                                        <div className="relative aspect-square overflow-hidden cursor-pointer" onClick={() => navigate(`/watches/${w.slug}`)}>
                                            <img src={w.cImgUrl} alt={w.brand} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                                            
                                            {!reviews.includes(w.id) && (
                                                <div className="absolute top-3 right-3 z-10 transition-transform group-hover:scale-110">
                                                    <div className="w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-lg" />
                                                </div>
                                            )}
                                        </div>
                                        
                                        <div className="p-4 space-y-3 flex-1 flex flex-col justify-between">
                                            <div>
                                                <p className="text-[10px] font-black text-mono tracking-widest uppercase mb-1">
                                                    {w.brand} | {w.year}
                                                </p>
                                                <p className="text-sm font-bold text-primary transition-colors line-clamp-1">
                                                    Compra Realizada
                                                </p>
                                            </div>
                                            
                                            <div className="flex flex-col gap-2">
                                                <button 
                                                    onClick={() => navigate(`/watches/${w.slug}`)} 
                                                    className="w-full py-2 bg-primary text-secondary font-black tracking-widest text-[9px] rounded-lg hover:bg-primary/95 transition-all active:scale-95 uppercase"
                                                >
                                                    Ver Produto
                                                </button>
                                                
                                                {!reviews.includes(w.id) && (
                                                    <button 
                                                        onClick={() => handleReviewModal(w)} 
                                                        className="w-full py-2 bg-secondary text-white font-black tracking-widest text-[9px] rounded-lg hover:opacity-95 transition-all active:scale-95 uppercase shadow-lg shadow-secondary/10"
                                                    >
                                                        Avaliar Agora
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                        }
                    </div>
            }
            {
                reviewModal && reviewWatch ?
                <ReviewModal watch={reviewWatch} close={() => setReviewModal(false)} refresh={getReviews}/>
                : null
            }
        </div>
    )
}